import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_IOStatements = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="I/O Statements"
    videos={[
      "https://www.youtube.com/embed/BeVQ8YmgBRQ", // Unformatted Input Functions in C
      "https://www.youtube.com/embed/m83PVLZ0PAo", // printf() and scanf() functions in C
    ]}
    takeaways={[
      { text: "Remember the correct format specifiers for each datatype:" },
      
      { text: "Understand how to take string inputs properly (e.g., using scanf(), gets(), fgets())." },
      { text: "Learn the differences between common I/O functions:" },
      { image: '/OOPSIOstatements.png'}
    ]}
    questions={[
      "What are the format specifiers for different data types?",
      "Explain the differences between getch(), getchar(), putch(), and putchar().",
      "How do you properly take string input in C?",
    ]}
    exampleVideos={[]} // No example videos
  />
);
}

export default OOPS_M1_IOStatements;
